/* ============================================================
   ALVARA HOME - shared engine
   Ported from the approved prototype (2026-07-31).
   Cart, drawer, and menu are owned by the Horizon theme; this file
   drives the brand choreography (overture, root map, spine), the
   buy-box plan toggle over real product forms, and the opt-in gate.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Chromium computes dash patterns in USER units when
     vector-effect: non-scaling-stroke is applied, ignoring pathLength
     normalization. Normalize every drawn stroke to its measured length. */
  function normDash(p, hidden) {
    if (!p) return;
    try { p.__L = p.getTotalLength(); } catch (e) { p.__L = 1; }
    p.style.strokeDasharray = p.__L + ' ' + p.__L;
    if (hidden) p.style.strokeDashoffset = p.__L;
  }

  /* ---------- Scroll reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Count-up stats ---------- */
  if ('IntersectionObserver' in window && !reduced) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null, dur = 1100;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        el.textContent = '0' + suffix;
        requestAnimationFrame(step);
      });
    }, { threshold: .6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Pollen drift (hero) ---------- */
  var pollen = $('#pollen');
  if (pollen && !reduced) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 22; i++) {
      var p = document.createElement('i');
      p.style.left = (Math.random() * 100) + '%';
      p.style.animationDuration = (13 + Math.random() * 16) + 's';
      p.style.animationDelay = (-Math.random() * 22) + 's';
      p.style.opacity = (.3 + Math.random() * .5);
      p.style.transform = 'scale(' + (.5 + Math.random()) + ')';
      frag.appendChild(p);
    }
    pollen.appendChild(frag);
  }

  /* ---------- Honey scroll rail ---------- */
  var railFill = $('#railFill');
  if (railFill) {
    var ticking = false;
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      railFill.style.height = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ============================================================
     OVERTURE SCRUB - persistent rAF, never gated behind scroll
     events; lerp-smoothed with snap threshold.
     ============================================================ */
  var ovSec = $('#overture');
  if (ovSec) {
    if ('IntersectionObserver' in window) {
      var wio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); wio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      $$('.wline', ovSec).forEach(function (el) { wio.observe(el); });
    } else {
      $$('.wline', ovSec).forEach(function (el) { el.classList.add('in'); });
    }

    if (!reduced) {
      ovSec.classList.add('ov-live');
      var ovMain = $('#ovThreadMain'), ovTail = $('#ovThreadTail'),
          ovBell = $('#ovBell'), ovHexEl = $('#ovHex'), ovYou = $('#ovYou');
      $$('.ov-thread path', ovSec).forEach(function (p) { normDash(p, true); });
      normDash(ovHexEl, true);
      var ovNet = $$('.ov-net', ovSec);
      ovNet.forEach(function (p) {
        var w = p.getAttribute('data-w').split(',');
        p.__a = +w[0]; p.__b = +w[1];
      });
      var ovTips = $$('.ov-tip', ovSec);
      ovTips.forEach(function (c) { c.__w = +c.getAttribute('data-w'); });

      var ovTop = 0, ovSpan = 1;
      var ovMeasure = function () {
        var r = ovSec.getBoundingClientRect();
        ovTop = r.top + window.scrollY;
        ovSpan = Math.max(ovSec.offsetHeight - window.innerHeight * .45, 1);
      };
      ovMeasure();
      window.addEventListener('resize', ovMeasure);
      window.addEventListener('load', ovMeasure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ovMeasure);
      var ovDrawn = -1, ovRung = false;
      var ovSeg = function (p, a, b) { return Math.min(Math.max((p - a) / (b - a), 0), 1); };
      (function ovLoop() {
        var t = Math.min(Math.max((window.scrollY + window.innerHeight * .5 - ovTop) / ovSpan, 0), 1);
        if (ovDrawn < 0) ovDrawn = t;
        ovDrawn += (t - ovDrawn) * .12;
        if (Math.abs(t - ovDrawn) < .0005) ovDrawn = t;
        if (ovMain) ovMain.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .04, .68)) * ovMain.__L;
        if (ovTail) ovTail.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .78, 1)) * ovTail.__L;
        for (var ni = 0; ni < ovNet.length; ni++) {
          ovNet[ni].style.strokeDashoffset = (1 - ovSeg(ovDrawn, ovNet[ni].__a, ovNet[ni].__b)) * ovNet[ni].__L;
        }
        for (var ti = 0; ti < ovTips.length; ti++) {
          ovTips[ti].style.opacity = .75 * ovSeg(ovDrawn, ovTips[ti].__w - .02, ovTips[ti].__w + .05);
        }
        var b = ovSeg(ovDrawn, .56, .72);
        if (ovBell) {
          ovBell.style.opacity = b;
          ovBell.style.letterSpacing = (.06 - .055 * b) + 'em';
          ovBell.style.transform = 'scale(' + (.985 + .015 * b) + ')';
        }
        if (ovHexEl) ovHexEl.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .62, .74)) * ovHexEl.__L;
        if (!ovRung && ovDrawn > .74 && ovYou) { ovRung = true; ovYou.classList.add('rung'); }
        requestAnimationFrame(ovLoop);
      })();
    }
  }

  /* ============================================================
     ROOT MAP + SPINE SCRUB - runtime-anchored, write-only frames.
     ============================================================ */
  var rmSec = $('.rootmap');
  if (rmSec) {
    var rmPinEl = $('#rmPin'), rmStage = $('#rmStage');
    var rmPinMode = window.matchMedia('(min-width: 760px)').matches && !reduced && 'IntersectionObserver' in window;
    rmSec.classList.add(rmPinMode ? 'rm-pinmode' : 'rm-flowmode');

    var rmCores = [], rmGlows = [], rmMotes = [], rmNodes = [];
    for (var ri = 0; ri < 6; ri++) {
      rmCores.push($('#rmC' + ri));
      rmMotes.push($('.rm-mote[data-m="' + ri + '"]', rmSec));
      rmNodes.push($('.rm-node[data-n="' + ri + '"]', rmSec));
    }
    $$('.rm-glow', rmSec).forEach(function (p) { if (!p.id) rmGlows.push(p); });
    $$('.rm-svg path', rmSec).forEach(function (p) { normDash(p, !reduced); });
    normDash($('#rmHex'), !reduced);

    function placeMotes() {
      rmCores.forEach(function (path, i) {
        if (!path || !rmMotes[i]) return;
        try {
          var pt = path.getPointAtLength(path.getTotalLength() * .7);
          rmMotes[i].style.left = pt.x + '%';
          rmMotes[i].style.top = pt.y + '%';
        } catch (e) {}
      });
    }
    placeMotes();

    if (window.matchMedia('(hover: hover)').matches) {
      rmNodes.forEach(function (node, i) {
        if (!node) return;
        node.addEventListener('mouseenter', function () {
          node.classList.add('hot');
          if (rmCores[i]) rmCores[i].classList.add('hot');
          var root = $('#rmRoot');
          if (root) { root.classList.remove('pulse'); void root.offsetWidth; root.classList.add('pulse'); }
        });
        node.addEventListener('mouseleave', function () {
          node.classList.remove('hot');
          if (rmCores[i]) rmCores[i].classList.remove('hot');
        });
      });
    }

    if (!rmPinMode) {
      if ('IntersectionObserver' in window) {
        var rio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { rmPinEl.classList.add('in'); rio.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -14% 0px' });
        if (rmStage) rio.observe(rmStage);
      } else if (rmPinEl) {
        rmPinEl.classList.add('in');
      }
    }

    var spWrap = $('#spWrap'), spSpine = $('#spSpine'), spBridge = $('#spBridge'),
        spGrid = $('#spGrid'), spCaption = $('#spCaption');
    var spCards = $$('.coh-card', spWrap || document.createElement('div')).sort(function (a, b) {
      return (+a.getAttribute('data-st')) - (+b.getAttribute('data-st'));
    });
    var spX = 50, spFracs = [0, 0, 0, 0], spBridgeAt = 1, spReady = false, spBridgeGone = false;
    function pct(v, whole) { return (v / whole) * 100; }

    function spMeasure() {
      if (!spWrap || !spSpine) return;
      var wr = spWrap.getBoundingClientRect();
      if (wr.height < 10) return;
      var mobile = window.matchMedia('(max-width: 880px)').matches;
      if (mobile) {
        spX = pct(14, wr.width);
      } else if (spGrid) {
        var gr = spGrid.getBoundingClientRect();
        spX = pct((gr.left + gr.width / 2) - wr.left, wr.width);
      }
      spSpine.setAttribute('d', 'M' + spX + ' 0 L' + spX + ' 100');
      normDash(spSpine, !reduced);
      spCards.forEach(function (card, i) {
        var cr = card.getBoundingClientRect();
        spFracs[i] = ((cr.top + 46) - wr.top) / wr.height;
      });
      var r1 = $('#rei1'), r2 = $('#rei2');
      if (r1 && r2 && spBridge) {
        var a = r1.getBoundingClientRect(), b2 = r2.getBoundingClientRect();
        var ax = pct(a.left + a.width / 2 - wr.left, wr.width), ay = pct(a.bottom + 6 - wr.top, wr.height);
        var bx = pct(b2.left + b2.width / 2 - wr.left, wr.width), by = pct(b2.top - 8 - wr.top, wr.height);
        var mx = spX, my = (ay + by) / 2;
        spBridge.setAttribute('d', 'M' + ax + ' ' + ay + ' C ' + ax + ' ' + (ay + 7) + ', ' + mx + ' ' + (my - 9) + ', ' + mx + ' ' + my +
          ' C ' + mx + ' ' + (my + 9) + ', ' + bx + ' ' + (by - 7) + ', ' + bx + ' ' + by);
        normDash(spBridge, !spBridgeGone && !reduced);
        spBridgeAt = Math.max(spFracs[3], my / 100) + .04;
      }
      spReady = true;
    }

    var rmTop = 0, rmSpan = 1;
    function rmMeasure() {
      var r = rmSec.getBoundingClientRect();
      rmTop = r.top + window.scrollY;
      rmSpan = Math.max(rmSec.offsetHeight - window.innerHeight, 1);
      spMeasure();
      placeMotes();
    }
    rmMeasure();
    window.addEventListener('resize', rmMeasure);
    window.addEventListener('load', rmMeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(rmMeasure);

    if (!reduced) {
      var rmDrawn = -1, spDrawn = -1, spPeak = 0;
      var seg2 = function (p, a, b) { return Math.min(Math.max((p - a) / (b - a), 0), 1); };
      var thWin = function (i) { return [.10 + i * .045, .36 + i * .045]; };
      var elHex = $('#rmHex'), elHalo = $('#rmHalo'), elTail = $('#rmTail'),
          elTailG = $('#rmTailG'), elDawn = $('#rmDawn');

      (function rmLoop() {
        if (rmPinMode && rmPinEl) {
          var t = Math.min(Math.max((window.scrollY - rmTop) / rmSpan, 0), 1);
          if (rmDrawn < 0) rmDrawn = t;
          rmDrawn += (t - rmDrawn) * .14;
          if (Math.abs(t - rmDrawn) < .0005) rmDrawn = t;
          var p = rmDrawn;

          /* Copy latches once revealed (scrolling back up must never
             hide content); the drawn ornament stays bidirectional. */
          if (p >= .02) rmPinEl.classList.add('p-eye');
          if (p >= .60) rmPinEl.classList.add('p-s1');
          if (p >= .70) rmPinEl.classList.add('p-s2');
          if (p >= .79) rmPinEl.classList.add('p-fl');
          if (p >= .84) rmPinEl.classList.add('p-cp');
          if (p >= .91) rmPinEl.classList.add('p-cta');

          for (var i = 0; i < 6; i++) {
            if (!rmCores[i]) continue;
            var w = thWin(i);
            var off = 1 - seg2(p, w[0], w[1]);
            rmCores[i].style.strokeDashoffset = off * rmCores[i].__L;
            if (rmGlows[i]) rmGlows[i].style.strokeDashoffset = off * rmGlows[i].__L;
            var o = .35 * seg2(p, .01 + i * .02, .04 + i * .02)
                  + .55 * seg2(p, w[0], w[0] + .06)
                  - .40 * seg2(p, .66, .74);
            if (rmNodes[i]) rmNodes[i].style.opacity = o;
            var segP = seg2(p, w[0], w[1]);
            if (rmMotes[i]) {
              if (segP >= .7 && !rmMotes[i].classList.contains('go')) rmMotes[i].classList.add('go');
              else if (segP < .62 && rmMotes[i].classList.contains('go')) rmMotes[i].classList.remove('go');
            }
          }
          if (elHex) elHex.style.strokeDashoffset = (1 - seg2(p, .58, .68)) * elHex.__L;
          if (elHalo) elHalo.style.opacity = seg2(p, .66, .74);
          var tailOff = 1 - seg2(p, .88, 1);
          if (elTail) elTail.style.strokeDashoffset = tailOff * elTail.__L;
          if (elTailG) elTailG.style.strokeDashoffset = tailOff * elTailG.__L;
          if (elDawn) elDawn.style.opacity = .85 * seg2(p, .86, 1);
        }

        if (spWrap && spReady && spSpine) {
          var wrTop2 = spWrap.getBoundingClientRect().top;
          var bp = Math.min(Math.max((window.innerHeight * .82 - wrTop2) / spWrap.offsetHeight, 0), 1);
          if (spDrawn < 0) spDrawn = bp;
          spDrawn += (bp - spDrawn) * .14;
          if (Math.abs(bp - spDrawn) < .0005) spDrawn = bp;
          var fracNow = seg2(spDrawn, .02, .92);
          /* Monotonic: the ink never un-draws, cards never un-reveal. */
          if (fracNow > spPeak) spPeak = fracNow;
          var frac = spPeak;
          spSpine.style.strokeDashoffset = (1 - frac) * spSpine.__L;
          for (var s = 0; s < 4; s++) {
            if (!spCards[s]) continue;
            if (frac >= spFracs[s]) spCards[s].classList.add('st-on');
          }
          if (!spBridgeGone && frac >= spBridgeAt && spBridge) {
            spBridgeGone = true;
            spBridge.classList.add('go');
            setTimeout(function () {
              var a1 = $('#rei1'), a2 = $('#rei2');
              if (a1) a1.classList.add('lit');
              if (a2) a2.classList.add('lit');
              if (spCaption) spCaption.classList.add('on');
            }, 1250);
          }
        }
        requestAnimationFrame(rmLoop);
      })();
    }

    var cohSec = $('#coherence');
    if (cohSec) {
      var setHot = function (c, on) {
        $$('.cmp[data-c="' + c + '"]', cohSec).forEach(function (el) { el.classList.toggle('hotc', on); });
      };
      cohSec.addEventListener('mouseover', function (e) {
        var t = e.target.closest('.cmp'); if (t) setHot(t.getAttribute('data-c'), true);
      });
      cohSec.addEventListener('mouseout', function (e) {
        var t = e.target.closest('.cmp'); if (t) setHot(t.getAttribute('data-c'), false);
      });
      cohSec.addEventListener('click', function (e) {
        var t = e.target.closest('.cmp');
        $$('.cmp.hotc', cohSec).forEach(function (el) { el.classList.remove('hotc'); });
        if (t) setHot(t.getAttribute('data-c'), true);
      });
    }
  }

  /* ============================================================
     BUY: plan toggle over two REAL product forms.
     The forms are Horizon <product-form-component> instances; the
     theme handles AJAX add + cart drawer. This JS only decides
     which form is active.
     ============================================================ */
  var optSub = $('#opt-sub'), optOnce = $('#opt-once');
  var formSub = $('#alvara-form-sub'), formOnce = $('#alvara-form-once');
  var satcPrice = $('#satcPrice');
  function activeForm() {
    return (optOnce && optOnce.classList.contains('sel')) ? formOnce : formSub;
  }
  function selectPlan(which) {
    if (!optSub || !optOnce) return;
    optSub.classList.toggle('sel', which === 'sub');
    optOnce.classList.toggle('sel', which === 'once');
    var rs = $('#rad-sub'), ro = $('#rad-once');
    if (rs) rs.checked = which === 'sub';
    if (ro) ro.checked = which === 'once';
    if (formSub) formSub.classList.toggle('bb-form-hidden', which !== 'sub');
    if (formOnce) formOnce.classList.toggle('bb-form-hidden', which !== 'once');
    if (satcPrice) {
      satcPrice.innerHTML = which === 'sub'
        ? (satcPrice.getAttribute('data-sub') || '')
        : (satcPrice.getAttribute('data-once') || '');
    }
  }
  if (optSub && optOnce) {
    optSub.addEventListener('click', function () { selectPlan('sub'); });
    optOnce.addEventListener('click', function () { selectPlan('once'); });
    selectPlan('sub');
  }

  /* Any [data-add] CTA submits the active (or subscription) product
     form through the theme's AJAX pipeline; falls back to scrolling
     to the buy section. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    if (btn.closest('form')) return; /* real submit buttons pass through */
    e.preventDefault();
    var form = (btn.getAttribute('data-add') === 'once' && formOnce) ? formOnce : (formSub || formOnce);
    var submit = form ? form.querySelector('button[type="submit"], button[name="add"]') : null;
    if (submit && !submit.disabled) {
      submit.click();
    } else {
      var buySec = $('#buy');
      if (buySec) buySec.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    }
  });

  /* ---------- Sticky ATC: silent until the overture has played ---------- */
  var stickyBar = $('#stickyAtc'), atcGate = $('#overture') || $('.alvara-hero'), buySec2 = $('#buy');
  if (stickyBar && buySec2 && 'IntersectionObserver' in window) {
    var pastGate = false, buyVisible = false;
    var updateSticky = function () {
      var show = pastGate && !buyVisible;
      stickyBar.classList.toggle('show', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
    };
    if (atcGate) {
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        pastGate = !e.isIntersecting && e.boundingClientRect.top < 0;
        updateSticky();
      }); }).observe(atcGate);
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { buyVisible = e.isIntersecting; updateSticky(); }); }, { threshold: .25 }).observe(buySec2);
  }

  /* ============================================================
     LAYERS: opt-in modal + video lightbox (scrim shared).
     ============================================================ */
  var scrim = $('#alvaraScrim'), optin = $('#optin'), lightbox = $('#lightbox');
  var openLayer = null, lastFocus = null;

  function focusables(root) {
    return $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function openLayerEl(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    openLayer = el;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('on'); }); }
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('alvara-locked');
    var target = focusSel ? $(focusSel, el) : null;
    setTimeout(function () { (target || focusables(el)[0] || el).focus(); }, 90);
  }
  function closeLayer() {
    if (!openLayer) return;
    openLayer.classList.remove('on');
    openLayer.setAttribute('aria-hidden', 'true');
    if (openLayer === lightbox) { var f = $('#lbFrame'); if (f) f.innerHTML = ''; }
    if (scrim) {
      scrim.classList.remove('on');
      setTimeout(function () { scrim.hidden = true; }, 350);
    }
    document.body.classList.remove('alvara-locked');
    openLayer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (scrim) scrim.addEventListener('click', closeLayer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayer) closeLayer();
    if (e.key === 'Tab' && openLayer) {
      var f = focusables(openLayer);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  var optinClose = $('#optinClose'); if (optinClose) optinClose.addEventListener('click', closeLayer);
  var lbClose = $('#lbClose'); if (lbClose) lbClose.addEventListener('click', closeLayer);
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLayer(); });
  if (optin) optin.addEventListener('click', function (e) { if (e.target === optin) closeLayer(); });

  document.addEventListener('click', function (e) {
    var oi = e.target.closest('[data-optin]');
    if (oi) { e.preventDefault(); openLayerEl(optin, '#optinEmail'); }
  });

  /* Native customer-form capture: Shopify posts and redirects back.
     On return, surface the right success state (and the gated code). */
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    var which = window.location.hash;
    if (which === '#optin-ok' && optin) {
      var ofrm = $('#optinFormWrap'), orev = $('#optinReveal');
      if (ofrm) ofrm.style.display = 'none';
      if (orev) {
        var codeEl = $('#optinCode');
        if (codeEl && optin.getAttribute('data-code')) codeEl.textContent = optin.getAttribute('data-code');
        orev.classList.add('on');
      }
      openLayerEl(optin);
    }
    if (which === '#hive-ok') {
      var hf = $('#hiveForm'), ok = $('#hiveOk');
      if (hf) hf.style.display = 'none';
      if (ok) { ok.classList.add('on'); ok.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); }
    }
  }
  var optinCopy = $('#optinCopy');
  if (optinCopy) optinCopy.addEventListener('click', function () {
    var codeEl2 = $('#optinCode');
    if (codeEl2 && navigator.clipboard) navigator.clipboard.writeText(codeEl2.textContent.trim());
    this.textContent = 'Copied';
  });

  /* ---------- Video lightbox (no YouTube request until click) ---------- */
  $$('[data-yt]').forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.getAttribute('data-yt');
      var title = card.getAttribute('data-title') || 'ALVARA video';
      var frame = $('#lbFrame');
      if (!frame || !lightbox) return;
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="' + title +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      openLayerEl(lightbox, '#lbClose');
    });
  });
})();
/* ===== PDP LAYER ===== */
/* ===== alvara-pdp-hero ===== */
try {
/* ALVARA PDP Hero + Path Chooser: path selection, CTA label + target form.
   Scoped per section root so multiple instances can live on one page. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.pdhReady === '1') return;
    root.dataset.pdhReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.pdh-card'));
    var cta = root.querySelector('.pdh-cta');
    if (!cards.length) return;

    var ctaText = cta ? cta.querySelector('.pdh-cta-t') : null;

    function applyPath(key) {
      if (!key) return;

      cards.forEach(function (card) {
        var on = card.getAttribute('data-path') === key;
        card.classList.toggle('sel', on);
        var radio = card.querySelector('.pdh-radio');
        if (radio && radio.checked !== on) radio.checked = on;
      });

      if (!cta) return;

      var formId = cta.getAttribute('data-form-' + key) || '';
      var label = cta.getAttribute('data-label-' + key) || '';
      var targetForm = formId ? document.getElementById(formId) : null;

      if (targetForm) {
        cta.setAttribute('form', formId);
        cta.disabled = false;
        cta.removeAttribute('aria-disabled');
      } else {
        cta.removeAttribute('form');
        cta.disabled = true;
        cta.setAttribute('aria-disabled', 'true');
      }

      if (label && ctaText) ctaText.textContent = label;
      cta.setAttribute('data-active-path', key);
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('.pdh-radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) applyPath(card.getAttribute('data-path'));
      });
    });

    var checked = root.querySelector('.pdh-radio:checked');
    var startCard = checked
      ? checked.closest('.pdh-card')
      : (root.querySelector('.pdh-card[data-default="true"]') || cards[0]);
    applyPath(startCard ? startCard.getAttribute('data-path') : null);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('.pdh[data-pdh]')) initSection(context);
    Array.prototype.forEach.call(
      context.querySelectorAll('.pdh[data-pdh]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();

} catch (e) { console.error("alvara-pdp-hero", e); }

/* ===== alvara-pdp-ingredients ===== */
try {
  document.querySelectorAll('.pin').forEach(function (sec) {
    var bigWrap = sec.querySelector('.pin-media-ing');
    var big = bigWrap ? bigWrap.querySelector('img') : null;
    sec.addEventListener('click', function (e) {
      var f = e.target.closest('.pin-filter');
      if (f) {
        sec.querySelectorAll('.pin-filter').forEach(function (x) { x.classList.toggle('is-on', x === f); x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        var cat = f.getAttribute('data-cat');
        sec.querySelectorAll('.pin-row').forEach(function (row) {
          row.classList.toggle('pin-hide', cat !== 'all' && row.getAttribute('data-cat') !== cat);
        });
        return;
      }
      var btn = e.target.closest('.pin-row-btn');
      if (!btn) return;
      var row = btn.closest('.pin-row');
      var wasOpen = row.classList.contains('is-open');
      sec.querySelectorAll('.pin-row.is-open').forEach(function (r) {
        r.classList.remove('is-open');
        r.querySelector('.pin-row-btn').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        row.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (big) {
          var thumb = row.querySelector('.pin-thumb img');
          if (thumb && big.getAttribute('src') !== thumb.getAttribute('src')) {
            bigWrap.classList.add('is-swapping');
            setTimeout(function () {
              big.src = thumb.src;
              big.onload = function () { bigWrap.classList.remove('is-swapping'); };
              setTimeout(function () { bigWrap.classList.remove('is-swapping'); }, 600);
            }, 180);
          }
        }
      }
    });
  });
} catch (e) { console.error('alvara-pdp-ingredients', e); }



/* ================= NINE PAGES JS (generated) ================= */

/* ===== alvara-pvx-hero ===== */
/* alvara-pvx-hero | VitalityX Experience, section 1.
   Adds .is-ready on the animation frame after DOMContentLoaded so the load
   sequence runs, hands the ken burns over to the ambient drift once the
   entrance scale finishes, and binds a light scroll parallax while the hero
   is on screen. Reduced motion gets .is-ready and nothing else. */
(function () {
  try {
    var SELECTOR = '[data-pvx-hero]';
    var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduced = !!(mql && mql.matches);

    function markReady(hero) {
      function go() { hero.classList.add('is-ready'); }
      if (typeof window.requestAnimationFrame !== 'function') {
        go();
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(go);
      });
      // rAF is starved in a background tab, so never let the copy stay hidden
      window.setTimeout(go, 1200);
    }

    function handOverToDrift(hero) {
      var frame = hero.querySelector('.pvx-hero__frame');
      if (!frame) return;
      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        hero.classList.add('is-drifting');
      }
      frame.addEventListener('transitionend', function (evt) {
        if (evt.propertyName === 'transform') settle();
      });
      // safety net if the transition never reports (tab hidden at load, etc)
      window.setTimeout(settle, 2900);
    }

    function bindParallax(hero) {
      var media = hero.querySelector('.pvx-hero__media');
      if (!media) return;

      var ticking = false;
      var bound = false;

      function paint() {
        // released first so a dropped frame can never strand the throttle
        ticking = false;
        var rect = hero.getBoundingClientRect();
        var height = rect.height || 1;
        var progress = -rect.top / height;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        media.style.transform = 'translate3d(0,' + (progress * height * 0.08).toFixed(2) + 'px,0)';
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(paint);
        // if that frame never arrives (hidden tab, throttled compositor) the
        // flag is released anyway so the next scroll is not swallowed
        window.setTimeout(function () { ticking = false; }, 300);
      }

      function bind() {
        if (bound) return;
        bound = true;
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      function unbind() {
        if (!bound) return;
        bound = false;
        window.removeEventListener('scroll', onScroll);
      }

      window.addEventListener('resize', onScroll, { passive: true });
      document.addEventListener('visibilitychange', function () {
        ticking = false;
        if (!document.hidden) onScroll();
      });

      // bound up front so the effect never depends on an observer callback,
      // the observer only releases the listener once the hero is off screen
      bind();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              bind();
              onScroll();
            } else {
              unbind();
            }
          }
        }, { rootMargin: '15% 0px 15% 0px' });
        observer.observe(hero);
      }

      paint();
    }

    function initHero(hero) {
      if (!hero || hero.getAttribute('data-pvx-init') === '1') return;
      hero.setAttribute('data-pvx-init', '1');
      markReady(hero);
      if (reduced) return;
      try { handOverToDrift(hero); } catch (err) {}
      try { bindParallax(hero); } catch (err) {}
    }

    function initAll(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var nodes = root.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (evt) {
      try { initAll(evt && evt.target ? evt.target : document); } catch (err) {}
    });
  } catch (err) {}
})();

/* ===== alvara-pvx-program ===== */
/* VitalityX Program (alvara-pvx-program)
   1. Scrubs a settle value onto the sticky heading column so it tightens and
      dims a little as the prose scrolls past it, instead of sitting frozen.
   2. Under reduced motion, hands the stat numerals their final value and
      strips the count hooks so the global counter observer leaves them alone. */
(function () {
  try {
    var SEL = '[data-pvx-program]';
    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var deskMQ = window.matchMedia ? window.matchMedia('(min-width: 1080px)') : null;
    var cols = [];
    var ticking = false;
    var bound = false;

    function reduced() {
      return !!(reduceMQ && reduceMQ.matches);
    }

    function settleCounters() {
      var nums = document.querySelectorAll(SEL + ' .pvx-stat-num');
      for (var i = 0; i < nums.length; i++) {
        var n = nums[i];
        var v = n.getAttribute('data-count');
        var s = n.getAttribute('data-suffix') || '';
        n.removeAttribute('data-count');
        n.removeAttribute('data-suffix');
        if (v) n.textContent = v + s;
      }
    }

    function collect() {
      cols = [];
      var secs = document.querySelectorAll(SEL);
      for (var i = 0; i < secs.length; i++) {
        var inner = secs[i].querySelector('.pvx-headcol-inner');
        var grid = secs[i].querySelector('.pvx-program-grid');
        if (inner && grid) cols.push({ inner: inner, grid: grid });
      }
    }

    function update() {
      ticking = false;
      var sticky = deskMQ ? deskMQ.matches : false;
      for (var i = 0; i < cols.length; i++) {
        var c = cols[i];
        if (!sticky) {
          c.inner.style.setProperty('--pvx-p', '0');
          continue;
        }
        var r = c.grid.getBoundingClientRect();
        var span = r.height - c.inner.offsetHeight;
        if (span <= 0) {
          c.inner.style.setProperty('--pvx-p', '0');
          continue;
        }
        var top = parseFloat(window.getComputedStyle(c.inner).top);
        if (isNaN(top)) top = 0;
        var p = (top - r.top) / span;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        c.inner.style.setProperty('--pvx-p', p.toFixed(3));
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function bind() {
      if (bound) return;
      bound = true;
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
      window.addEventListener('orientationchange', request, { passive: true });
      /* rAF is parked while the tab is hidden, which would leave the ticking
         flag stuck true and kill the scrub. Clear it on the way back. */
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          ticking = false;
          request();
        }
      });
      document.addEventListener('shopify:section:load', function () {
        collect();
        ticking = false;
        update();
      });
    }

    function init() {
      if (reduced()) {
        settleCounters();
        collect();
        update();
        return;
      }
      collect();
      if (!cols.length) return;
      update();
      bind();
    }

    if (reduced()) settleCounters();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (e) {}
})();


/* ===== alvara-pvx-foundation ===== */
/* ============================================================
   alvara-pvx-foundation  /  VitalityX Foundation
   Background parallax at roughly 12 percent, plus a local reveal
   fallback so the section still animates if it is inserted after
   the global observer has run (theme editor, section reload).
   ============================================================ */
(function () {
  try {
    var PVX_SEL = '[data-pvx-foundation]';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var layers = [];
    var ticking = false;

    function list(root, sel) {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function revealFallback(sec) {
      var items = list(sec, '.reveal');
      if (!items.length) return;
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) {
        if (!el.classList.contains('in')) io.observe(el);
      });
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < layers.length; i++) {
        var sec = layers[i].sec;
        var layer = layers[i].layer;
        var r = sec.getBoundingClientRect();
        if (r.bottom < -240 || r.top > vh + 240) continue;
        var span = vh + r.height;
        var progress = span > 0 ? (vh - r.top) / span : 0;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        var shift = (0.5 - progress) * (r.height * 0.12);
        layer.style.setProperty('--pvx-par', shift.toFixed(2) + 'px');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function bindParallax(sec) {
      var layer = sec.querySelector('.pvx-fnd-par');
      if (!layer) return;
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].sec === sec) return;
      }
      layer.style.willChange = 'transform';
      layers.push({ sec: sec, layer: layer });
    }

    function init(root) {
      var sections = list(root, PVX_SEL);
      if (root && root.matches && root.matches(PVX_SEL)) sections.push(root);
      sections.forEach(function (sec) {
        revealFallback(sec);
        if (!reduced && 'requestAnimationFrame' in window) bindParallax(sec);
      });
      if (layers.length) update();
    }

    function boot() { init(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    if (!reduced) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      try { init(e.target || document); } catch (err) {}
    });
  } catch (e) {}
})();

/* ===== alvara-pvx-guides ===== */
/* VitalityX Guides: counter-parallax between each portrait and its text column. */
(function () {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var rows = document.querySelectorAll('[data-pvx-guide]');
    if (!rows.length || !('IntersectionObserver' in window)) return;

    var live = [];
    var ticking = false;

    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (!vh) return;
      for (var i = 0; i < live.length; i++) {
        var row = live[i];
        var r = row.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        var span = vh / 2 + r.height / 2;
        var prog = span ? (mid - vh / 2) / span : 0;
        if (prog > 1) prog = 1;
        if (prog < -1) prog = -1;
        var amp = r.height * 0.05;
        if (amp > 56) amp = 56;
        row.style.setProperty('--pvx-par', (prog * amp).toFixed(2) + 'px');
      }
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        var at = live.indexOf(el);
        if (entries[i].isIntersecting) {
          if (at < 0) live.push(el);
        } else if (at >= 0) {
          live.splice(at, 1);
          el.style.setProperty('--pvx-par', '0px');
        }
      }
      if (live.length) schedule();
    }, { rootMargin: '25% 0px 25% 0px', threshold: 0 });

    for (var i = 0; i < rows.length; i++) io.observe(rows[i]);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    /* A backgrounded tab never fires the pending frame, so clear the latch on return. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { ticking = false; schedule(); }
    });

    schedule();
  } catch (e) {}
})();

/* ===== alvara-pvx-call ===== */
/* VitalityX Begin (alvara-pvx-call): hex glyph lift on entry, one shine sweep on the button */
(function () {
  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = null;

    function sweep(btn) {
      btn.classList.add('pvx-call-swept');
      var clear = function () {
        btn.classList.remove('pvx-call-swept');
        btn.removeEventListener('animationend', clear);
      };
      btn.addEventListener('animationend', clear);
      window.setTimeout(clear, 1800);
    }

    function light(sec) {
      if (sec.getAttribute('data-pvx-lit') === '1') return;
      sec.setAttribute('data-pvx-lit', '1');
      sec.classList.add('pvx-lit');
      if (reduce) return;
      var btn = sec.querySelector('.pvx-call__btn');
      if (!btn) return;
      /* the button lands at 300ms delay plus its 850ms rise, so sweep 400ms after that */
      window.setTimeout(function () { sweep(btn); }, 1550);
    }

    function init() {
      var sections = document.querySelectorAll('.pvx-call');
      if (!sections.length) return;

      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(sections, light);
        return;
      }

      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            light(entry.target);
            io.unobserve(entry.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px -18% 0px' });
      }

      Array.prototype.forEach.call(sections, function (sec) {
        if (sec.getAttribute('data-pvx-lit') === '1') return;
        io.observe(sec);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  } catch (e) {}
})();

/* ===== alvara-psa-hero ===== */
/* ALVARA Sanctuary hero: load entrance, image-gated wipe, immediate stat count */
(function () {
  try {
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reduced() { return !!(mq && mq.matches); }

    function countUp(el) {
      if (!el || el.getAttribute('data-psa-counted') === '1') { return; }
      var raw = (el.getAttribute('data-count') || '').replace(/[^0-9.\-]/g, '');
      var target = parseFloat(raw);
      if (isNaN(target)) { return; }
      el.setAttribute('data-psa-counted', '1');
      var suffix = el.getAttribute('data-suffix') || '';
      var dot = raw.indexOf('.');
      var dec = dot === -1 ? 0 : raw.length - dot - 1;
      var settled = target.toFixed(dec) + suffix;
      if (reduced()) { el.textContent = settled; return; }
      var dur = 1400;
      var t0 = null;
      el.textContent = (0).toFixed(dec) + suffix;
      function frame(ts) {
        if (t0 === null) { t0 = ts; }
        var p = Math.min(1, (ts - t0) / dur);
        var value = target * (1 - Math.pow(1 - p, 3));
        var shown = parseFloat((el.textContent || '').replace(/[^0-9.\-]/g, ''));
        if (!isNaN(shown) && shown > value) { value = shown; }
        if (p < 1) {
          el.textContent = value.toFixed(dec) + suffix;
          requestAnimationFrame(frame);
        } else {
          el.textContent = settled;
        }
      }
      requestAnimationFrame(frame);
    }

    function play(root) {
      if (root.getAttribute('data-psa-played') === '1') { return; }
      root.setAttribute('data-psa-played', '1');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('psa-hero--in');
          var num = root.querySelector('.psa-hero__num');
          if (reduced()) {
            countUp(num);
          } else {
            setTimeout(function () { countUp(num); }, 360);
          }
          setTimeout(function () { root.classList.add('psa-hero--settled'); }, 2100);
        });
      });
    }

    function init(root) {
      if (!root) { return; }
      var img = root.querySelector('.psa-hero__img');
      if (!img || img.complete || typeof img.decode !== 'function') { play(root); return; }
      var fired = false;
      function go() { if (!fired) { fired = true; play(root); } }
      try { img.decode().then(go, go); } catch (err) { go(); }
      setTimeout(go, 1200);
    }

    function boot(scope) {
      var nodes = (scope || document).querySelectorAll('.psa-hero');
      Array.prototype.forEach.call(nodes, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var host = e && e.target;
      if (!host || !host.querySelector) { return; }
      var root = host.classList && host.classList.contains('psa-hero') ? host : host.querySelector('.psa-hero');
      if (!root) { return; }
      root.removeAttribute('data-psa-played');
      root.classList.remove('psa-hero--in');
      root.classList.remove('psa-hero--settled');
      var num = root.querySelector('.psa-hero__num');
      if (num) { num.removeAttribute('data-psa-counted'); }
      init(root);
    });
  } catch (err) {}
})();

/* ===== alvara-psa-one-land ===== */
/* ============================================================
   SANCTUARY  ·  02  ONE LAND
   Clamped, rAF-throttled scroll scrub on the panorama plate.
   The observer gates the loop so it never runs off screen.
   ============================================================ */
(function () {
  'use strict';
  try {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function psaOneLandInit() {
      if (reduced) return;
      var frames = document.querySelectorAll('[data-psa-oneland] .psa-ol-plate-frame');
      if (!frames.length) return;

      Array.prototype.forEach.call(frames, function (frame) {
        if (frame.getAttribute('data-psa-scrub') === '1') return;
        frame.setAttribute('data-psa-scrub', '1');

        var img = frame.querySelector('.psa-ol-plate-img');
        if (!img) return;

        var active = false;
        var ticking = false;

        function paint() {
          ticking = false;
          var r = frame.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var span = r.height + vh;
          if (span <= 0) return;
          var p = (vh - r.top) / span;
          if (p < 0) { p = 0; } else if (p > 1) { p = 1; }
          img.style.setProperty('--psa-ol-p', p.toFixed(4));
        }

        function onScroll() {
          if (!active || ticking) return;
          ticking = true;
          window.requestAnimationFrame(paint);
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              active = entries[i].isIntersecting;
              if (active) { onScroll(); }
            }
          }, { rootMargin: '15% 0px 15% 0px' });
          io.observe(frame);
        } else {
          active = true;
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        paint();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', psaOneLandInit);
    } else {
      psaOneLandInit();
    }
    document.addEventListener('shopify:section:load', psaOneLandInit);
  } catch (e) { /* motion is decoration, never block the page */ }
})();


/* ===== alvara-psa-bridge ===== */
/* Sanctuary Bridge: thread draw normalization, entrance sequencing, background scrub. */
(function () {
  try {
    var SELECTOR = '[data-psa-bridge]';

    function prefersReduced() {
      try {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      } catch (e) {
        return false;
      }
    }

    function normalizeThreads(root) {
      var paths = root.querySelectorAll('.psa-thread__path');
      for (var i = 0; i < paths.length; i++) {
        var len = 200;
        try {
          var measured = paths[i].getTotalLength();
          if (measured && isFinite(measured) && measured > 0) {
            len = measured;
          }
        } catch (e) {}
        /* Dash values live in user units, so normalize off the measured length
           rather than trusting pathLength under a stretched viewBox. */
        paths[i].style.setProperty('--psa-len', String(Math.ceil(len) + 1));
      }
    }

    function attachScrub(root) {
      var photo = root.querySelector('.psa-bridge__photo');
      if (!photo || !('IntersectionObserver' in window)) return;

      var ticking = false;
      var listening = false;

      function update() {
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var span = rect.height + vh;
        var p = span > 0 ? (vh - rect.top) / span : 0;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        root.style.setProperty('--psa-p', p.toFixed(4));
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          /* Released before the work runs so a throw can never deadlock the gate. */
          ticking = false;
          update();
        });
      }

      function start() {
        if (listening) return;
        listening = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      }

      function stop() {
        if (!listening) return;
        listening = false;
        ticking = false;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }

      var visible = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            start();
          } else {
            stop();
          }
        }
      }, { rootMargin: '20% 0px 20% 0px' });

      visible.observe(root);
      document.addEventListener('visibilitychange', function () {
        ticking = false;
      });
      update();
    }

    function initBridge(root) {
      if (!root || root.getAttribute('data-psa-ready') === '1') return;
      root.setAttribute('data-psa-ready', '1');

      normalizeThreads(root);
      root.classList.add('psa-bridge-armed');

      if (prefersReduced() || !('IntersectionObserver' in window)) {
        root.classList.add('psa-in');
        return;
      }

      var entrance = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            root.classList.add('psa-in');
            entrance.disconnect();
          }
        }
        /* Threshold 0 plus a bottom inset, so a section taller than the
           viewport can still satisfy the entrance condition. */
      }, { threshold: 0, rootMargin: '0px 0px -14% 0px' });

      entrance.observe(root);
      attachScrub(root);
    }

    function initAll(scope) {
      var ctx = scope && scope.querySelectorAll ? scope : document;
      if (ctx.matches && ctx.matches(SELECTOR)) initBridge(ctx);
      var nodes = ctx.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) initBridge(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        try { initAll(document); } catch (e) {}
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      try { initAll(event.target); } catch (e) {}
    });
  } catch (e) {}
})();

/* ===== alvara-psa-council ===== */
/* ============================================================
   ALVARA Sanctuary  ·  Land Stewardship Council (alvara-psa-council)
   1. Honeycomb cells fill one at a time on entrance. A single
      IntersectionObserver adds .psa-cn-live and CSS transition-delay
      does the sequencing.
   2. The oak band's inner image slides on a clamped scrub.
      Written straight into the passive scroll handler rather than
      behind a rAF gate, so an occluded or throttled frame loop can
      never deadlock the scrub.
   ============================================================ */
(function () {
  'use strict';

  var reduced = false;
  try {
    reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {}

  var toArr = function (list) { return Array.prototype.slice.call(list || []); };

  var combObserver = null;
  var plateObserver = null;
  var livePlates = [];
  var scrubBound = false;

  function litAll() {
    toArr(document.querySelectorAll('[data-psa-cn-comb]')).forEach(function (el) {
      el.classList.add('psa-cn-live');
    });
  }

  function scrubPlate(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var span = vh + r.height;
    var p = span > 0 ? (vh - r.top) / span : 0.5;
    if (p < 0) { p = 0; } else if (p > 1) { p = 1; }
    el.style.setProperty('--psa-p', p.toFixed(4));
  }

  function scrubAll() {
    for (var i = 0; i < livePlates.length; i++) { scrubPlate(livePlates[i]); }
  }

  function bindScrub() {
    if (scrubBound) { return; }
    scrubBound = true;
    window.addEventListener('scroll', scrubAll, { passive: true });
    window.addEventListener('resize', scrubAll);
    window.addEventListener('orientationchange', scrubAll);
  }

  function initCombs(scope) {
    var combs = toArr(scope.querySelectorAll('[data-psa-cn-comb]')).filter(function (el) {
      if (el.getAttribute('data-psa-cn-ready') === '1') { return false; }
      el.setAttribute('data-psa-cn-ready', '1');
      return true;
    });
    if (!combs.length) { return; }

    if (reduced || !('IntersectionObserver' in window)) {
      combs.forEach(function (el) { el.classList.add('psa-cn-live'); });
      return;
    }

    if (!combObserver) {
      combObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          combObserver.unobserve(entry.target);
          entry.target.classList.add('psa-cn-live');
        });
      }, { threshold: 0.32, rootMargin: '0px 0px -6% 0px' });
    }
    combs.forEach(function (el) { combObserver.observe(el); });
  }

  function initPlates(scope) {
    var plates = toArr(scope.querySelectorAll('[data-psa-cn-plate]')).filter(function (el) {
      if (el.getAttribute('data-psa-cn-ready') === '1') { return false; }
      el.setAttribute('data-psa-cn-ready', '1');
      return true;
    });
    if (!plates.length || reduced) { return; }

    if (!('IntersectionObserver' in window)) {
      plates.forEach(function (el) {
        if (livePlates.indexOf(el) === -1) { livePlates.push(el); }
      });
      bindScrub();
      scrubAll();
      return;
    }

    if (!plateObserver) {
      plateObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var at = livePlates.indexOf(entry.target);
          if (entry.isIntersecting) {
            if (at === -1) { livePlates.push(entry.target); }
            scrubPlate(entry.target);
          } else if (at !== -1) {
            livePlates.splice(at, 1);
          }
        });
      }, { rootMargin: '25% 0px 25% 0px' });
    }
    plates.forEach(function (el) { plateObserver.observe(el); });
    bindScrub();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      initCombs(scope);
      initPlates(scope);
      /* Sections injected by the theme editor after load are never seen by the
         global .reveal observer, so latch them visible here. */
      if (root && root !== document) {
        toArr(scope.querySelectorAll('.reveal')).forEach(function (el) { el.classList.add('in'); });
      }
    } catch (e) {
      try { litAll(); } catch (e2) {}
    }
  }

  try {
    init(document);
    document.addEventListener('shopify:section:load', function (evt) {
      if (evt && evt.target && evt.target.querySelector &&
          evt.target.querySelector('[data-psa-cn-comb], [data-psa-cn-plate]')) {
        init(evt.target);
      }
    });
  } catch (e) {
    try { litAll(); } catch (e2) {}
  }
})();


/* ===== alvara-psa-land-ladder ===== */
/* Sanctuary Land Ladder :: alvara-psa-land-ladder
   Growing gold spine, node ignition, column shear and chip cascade.
   One rAF throttled scroll pass serves every instance on the page. */
(function () {
  try {
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduced = !!(mq && mq.matches);
    var items = [];
    var ticking = false;
    var bound = false;

    function clamp01(v) {
      return v < 0 ? 0 : (v > 1 ? 1 : v);
    }

    function collect() {
      items = [];
      var all = document.querySelectorAll('[data-psa-ladder]');
      Array.prototype.forEach.call(all, function (sec) {
        sec.classList.add('is-js');
        items.push({
          rail: sec.querySelector('[data-psa-rail]'),
          rows: Array.prototype.slice.call(sec.querySelectorAll('[data-psa-row]'))
        });
      });
    }

    function measure() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return;

      for (var i = 0; i < items.length; i++) {
        var it = items[i];

        if (it.rail) {
          var rr = it.rail.getBoundingClientRect();
          if (rr.height > 0 && rr.bottom > -vh && rr.top < vh * 2) {
            var denom = Math.max(1, rr.height - vh * 0.22);
            it.rail.style.setProperty('--psa-p', clamp01((vh * 0.78 - rr.top) / denom).toFixed(4));
          }
        }

        for (var r = 0; r < it.rows.length; r++) {
          var row = it.rows[r];
          var b = row.getBoundingClientRect();
          if (b.bottom < -240 || b.top > vh + 240) continue;

          var visible = Math.min(b.bottom, vh) - Math.max(b.top, 0);
          var reference = Math.min(b.height, vh) || 1;
          var ratio = clamp01(visible / reference);

          if (ratio > 0.1) row.classList.add('is-lit');
          if (ratio > 0.4) row.classList.add('is-chips');

          if (reduced) continue;

          var rp = clamp01((vh - b.top) / ((vh + b.height) || 1));
          var shift = (rp - 0.5) * 2;
          var imgAmp = Math.min(56, b.height * 0.05);
          var txtAmp = Math.min(18, b.height * 0.015);
          row.style.setProperty('--psa-img-y', (-shift * imgAmp).toFixed(2) + 'px');
          row.style.setProperty('--psa-txt-y', (-shift * txtAmp).toFixed(2) + 'px');
        }
      }
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function bind() {
      if (bound) return;
      bound = true;
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      window.addEventListener('orientationchange', request);
      window.addEventListener('load', request);
      if (mq) {
        var onChange = function () {
          reduced = mq.matches;
          request();
        };
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else if (mq.addListener) mq.addListener(onChange);
      }
    }

    function start() {
      collect();
      if (!items.length) return;
      bind();
      request();
      window.setTimeout(request, 320);
      window.setTimeout(request, 1200);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function () {
      try { start(); } catch (err) {}
    });

    document.addEventListener('shopify:section:unload', function () {
      try { start(); } catch (err) {}
    });
  } catch (e) {}
})();

/* ===== alvara-psa-regenerative ===== */
/* ALVARA Sanctuary · alvara-psa-regenerative
   Background scrub 1.12 to 1.0 across the section's scroll range, gold horizon
   drawn at 30% progress, paper quote card lifting in at 70% progress.
   rAF throttled, IntersectionObserver gated so the loop is torn down off screen. */
(function () {
  try {
    var SEL = '[data-psa-regen]';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hasIO = typeof window.IntersectionObserver === 'function';

    function initRegen(root) {
      if (!root || root.getAttribute('data-psa-ready') === '1') return;
      root.setAttribute('data-psa-ready', '1');

      var img = root.querySelector('.psa-regenerative-bg-img');
      var card = root.querySelector('.psa-card');

      if (reduce || !hasIO) {
        root.classList.add('psa-regenerative-armed', 'psa-horizon-in');
        if (card && hasIO) {
          var io0 = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                root.classList.add('psa-quote-in');
                io0.disconnect();
                break;
              }
            }
          }, { threshold: 0.25 });
          io0.observe(card);
        } else {
          root.classList.add('psa-quote-in');
        }
        return;
      }

      root.classList.add('psa-regenerative-armed');

      var ticking = false;
      var active = false;
      var ruleDone = false;
      var quoteDone = false;

      function update() {
        ticking = false;

        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var span = rect.height + vh;
        var p = span > 0 ? (vh - rect.top) / span : 0;
        if (p < 0) p = 0;
        if (p > 1) p = 1;

        if (img) img.style.setProperty('--psa-scale', (1.12 - 0.12 * p).toFixed(4));

        if (!ruleDone && p >= 0.30) {
          ruleDone = true;
          root.classList.add('psa-horizon-in');
        }

        if (!quoteDone) {
          var show = p >= 0.70;
          if (!show && card && p >= 0.50) {
            var cr = card.getBoundingClientRect();
            show = cr.top >= 0 && cr.bottom <= vh - 24;
          }
          if (show) {
            quoteDone = true;
            root.classList.add('psa-quote-in');
          }
        }
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      function start() {
        if (active) return;
        active = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      function stop() {
        if (!active) return;
        active = false;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            start();
          } else {
            stop();
          }
        }
      }, { rootMargin: '160px 0px 160px 0px', threshold: 0 });

      io.observe(root);
      update();
    }

    function initAll(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      var nodes = scope.querySelectorAll(SEL);
      for (var i = 0; i < nodes.length; i++) initRegen(nodes[i]);
      if (scope !== document && scope.matches && scope.matches(SEL)) initRegen(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target) initAll(e.target);
    });
  } catch (e) {}
})();

/* ===== alvara-psa-foundation ===== */
/* ALVARA Sanctuary / 07 Foundation: hex seals draw their outline as each portal lands */
(function () {
  try {
    var SEL = '[data-psa-foundation]';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function primeSeal(path) {
      if (path.getAttribute('data-psa-seal-primed') === '1') return;
      path.setAttribute('data-psa-seal-primed', '1');
      var len = 0;
      try { len = path.getTotalLength(); } catch (err) { len = 0; }
      if (!len || !isFinite(len)) {
        path.style.strokeDasharray = 'none';
        path.style.strokeDashoffset = '0';
        return;
      }
      len = Math.ceil(len);
      path.style.strokeDasharray = len + ' ' + len;
      path.style.strokeDashoffset = reduce ? '0' : String(len);
    }

    function drawCard(card) {
      var paths = card.querySelectorAll('.psa-portal__seal-draw');
      for (var i = 0; i < paths.length; i++) paths[i].style.strokeDashoffset = '0';
      card.classList.add('psa-is-sealed');
    }

    function initSection(root) {
      if (!root || root.getAttribute('data-psa-foundation-ready') === '1') return;
      root.setAttribute('data-psa-foundation-ready', '1');

      var cards = root.querySelectorAll('.psa-portal');
      var i, j;

      for (i = 0; i < cards.length; i++) {
        var seals = cards[i].querySelectorAll('.psa-portal__seal-draw');
        for (j = 0; j < seals.length; j++) primeSeal(seals[j]);
      }

      if (reduce || typeof window.IntersectionObserver !== 'function') {
        for (i = 0; i < cards.length; i++) drawCard(cards[i]);
        return;
      }

      var io = new IntersectionObserver(function (entries, observer) {
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          var card = entries[k].target;
          observer.unobserve(card);
          var delay = parseInt(card.getAttribute('data-psa-seal-delay') || '0', 10);
          if (isNaN(delay) || delay < 0) delay = 0;
          (function (el, wait) {
            window.setTimeout(function () { drawCard(el); }, wait);
          })(card, delay + 220);
        }
      }, { threshold: 0.25, rootMargin: '0px 0px -6% 0px' });

      for (i = 0; i < cards.length; i++) io.observe(cards[i]);
    }

    function boot() {
      var roots = document.querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (evt) {
      try {
        var t = evt && evt.target;
        if (!t || !t.querySelector) return;
        var root = (t.matches && t.matches(SEL)) ? t : t.querySelector(SEL);
        if (!root) return;
        root.removeAttribute('data-psa-foundation-ready');
        initSection(root);
      } catch (err) {}
    });
  } catch (err) {}
})();

/* ===== alvara-psa-support ===== */
try {
  (function () {
    var sections = document.querySelectorAll('.psa-sec');
    if (!sections.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    var isReduced = function () {
      return !!(reduce && reduce.matches);
    };

    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.getAttribute('data-psa-init') === '1') return;
      sec.setAttribute('data-psa-init', '1');

      var img = sec.querySelector('.psa-support-bg-img');
      var cta = sec.querySelector('.psa-cta');
      var wrap = cta ? cta.parentNode : null;
      var active = false;
      var ticking = false;

      /* clamped scrub: the dusk light drifts 4% vertically across the pass */
      function applyDrift() {
        ticking = false;
        if (!img || isReduced()) return;
        var rect = sec.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var span = vh + rect.height;
        if (span <= 0) return;
        var p = (vh - rect.top) / span;
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        sec.style.setProperty('--psa-y', ((p - 0.5) * 4).toFixed(3) + '%');
      }

      function onScroll() {
        if (ticking || !active) return;
        ticking = true;
        window.requestAnimationFrame(applyDrift);
      }

      if (img) {
        if ('IntersectionObserver' in window) {
          var driftObserver = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              active = entries[i].isIntersecting;
              if (active) onScroll();
            }
          }, { rootMargin: '140px 0px' });
          driftObserver.observe(sec);
        } else {
          active = true;
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        applyDrift();
      }

      /* shine sweep: once after the button lands, then hover or focus-visible only */
      if (cta) {
        var fired = false;

        var fire = function () {
          if (isReduced()) return;
          cta.classList.remove('psa-fire');
          void cta.offsetWidth;
          cta.classList.add('psa-fire');
        };

        var landed = function () {
          if (fired) return;
          fired = true;
          window.setTimeout(fire, 400);
        };

        cta.addEventListener('animationend', function () {
          cta.classList.remove('psa-fire');
        });

        cta.addEventListener('pointerenter', fire);

        cta.addEventListener('focus', function () {
          var visible = true;
          try {
            visible = cta.matches(':focus-visible');
          } catch (err) {
            visible = true;
          }
          if (visible) fire();
        });

        if (wrap && wrap.classList && wrap.classList.contains('psa-cta-wrap')) {
          wrap.addEventListener('transitionend', function (e) {
            if (e.propertyName === 'opacity') landed();
          });
        }

        if ('IntersectionObserver' in window) {
          var ctaObserver = new IntersectionObserver(function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                ctaObserver.disconnect();
                window.setTimeout(landed, 1800);
              }
            }
          }, { threshold: 0.5 });
          ctaObserver.observe(cta);
        } else {
          window.setTimeout(landed, 1800);
        }
      }
    });
  })();
} catch (e) {}

/* ================= END NINE PAGES JS ================= */